import React, { useState, useMemo } from 'react'
import { Box, IconButton } from '@mui/material'
import { ResizableBox } from 'react-resizable'
import { ChevronRight } from '@mui/icons-material'

import '../styles/css/patients.css'
import { CustomHandle, dashBoxStyle } from '../styles/js/Dashboard.style'
import PatientViewer from '../component/patient/PatientViewer'
import PatientsList from '../component/patient/PatientsList'


const Patients = () => {
    const [showList, setShowList] = useState<boolean>(true)
    const [selectedPatientId, setSelectedPatientId] = useState<number>(0)

    const handleShowList = () => setShowList(prevState => !prevState)

    const showViewer = (data: number) => {
        setSelectedPatientId(prevNumber => {
            if (prevNumber === data) return prevNumber
            else return data
        })
    }

    const MemoizedPatients = useMemo(() =>
        <PatientsList handleShowList={handleShowList} showViewer={showViewer} />
    , [])   // eslint-disable-line

    const reloadViewer = () => {
        const temp = selectedPatientId
        setSelectedPatientId(0)
        setTimeout(() => setSelectedPatientId(temp), 0)
    }
    
    return (
        <Box sx={dashBoxStyle}>
            <Box className='d-flex'>
            <ResizableBox 
                width={400}
                height={Infinity}
                minConstraints={[400, Infinity]}
                maxConstraints={[1000, Infinity]}
                handle={showList ? <CustomHandle /> : null}
                className='position-relative'
                style={{ display: showList ? 'unset' : 'none' }}
            >
                {MemoizedPatients}
            </ResizableBox>
            {!showList
                ? <IconButton onClick={handleShowList} aria-label='Open directory' color="primary">
                <ChevronRight />
                </IconButton>
                : null
            }
            </Box>
            <PatientViewer patientId={selectedPatientId} reloadViewer={reloadViewer} />
        </Box>
    )
}

export default Patients